import React, { useState } from "react";
import { Button, FormGroup, FormControl } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { WIDGET_NAME } from "../../constants";
import { updateWidgetRegistration } from "../../../../../../../api/cp/widgetRegistration";
import SettingTabWrapper from "../../../components/SettingTabWrapper";
import CommonSettings from "../SettingsScreen/CommonSettings";
import FieldsSequence from "../SettingsScreen/FieldsSequence";
import FieldsStyles from "../SettingsScreen/FieldsStyles";
import TextSettings from "../SettingsScreen/TextSettings";
import ScreensContent from "../SettingsScreen/ScreensContent";
import YandexMetrika from "../SettingsScreen/YandexMetrica";

import './styles.scss';

const SettingsSidebar = ({
    eventPassword,
    eventSettings,
    eventName,
    accessPreModeration,
    widgetKey,
    participationType,
    registrationType,
    isFormVisible,
    onUpdateModel,
    onUpdatePreview,
    onChangeScreen,
}) => {
    const history = useHistory();
    const [model, setModel] = useState(null);
    const [isSaving, setSaving] = useState(false);

    const handleUpdateModel = (value) => {
        setModel((prevState) => ({
            ...prevState,
            ...value,
        }));

        onUpdateModel(value);
    };

    const handleSaveModel = async () => {
        try {
            setSaving(true);
            await updateWidgetRegistration(widgetKey, model);

            const timer = setTimeout(() => {
                setSaving(false);
                clearTimeout(timer);
            }, 1200);
        } catch (error) {
            console.error(error);
            setSaving(false);
        }
    };

    return (
        <FormGroup className="settings-sidebar">
            <FormGroup style={{display: 'flex', columnGap: '12px'}}>
                <Button
                    bsStyle="primary"
                    disabled={isSaving}
                    onClick={handleSaveModel}
                >
                    Сохранить
                </Button>
                <Button
                    disabled={isSaving}
                    onClick={() => history.push(`/event/${eventPassword}/widgets/new-registration`)}
                >
                    Закрыть
                </Button>
            </FormGroup>
            {isSaving && (
                <p style={{fontStyle: 'italic', fontWeight: 'bold'}}>
                    Настройки успешно сохранены!
                </p>
            )}

            <FormGroup>
                <FormControl
                    type="text"
                    placeholder="Введите название виджета"
                    maxLength={50}
                    defaultValue={eventSettings?.[WIDGET_NAME] || ''}
                    onChange={(e) => setModel({...model, [WIDGET_NAME]: e.target.value})}
                    onBlur={(e) => onUpdateModel({[WIDGET_NAME]: e.target.value})}
                />
            </FormGroup>

            <FormGroup className="settings-sidebar__buttons">
                <button
                    className={`settings-sidebar__screen-button ${isFormVisible ? 'active' : ''}`}
                    onClick={() => onChangeScreen(true)}
                >
                    <img src="/player/images/eye.svg" alt="" width="24px" height="24px" />
                    Первый экран
                </button>
                <button
                    className={`settings-sidebar__screen-button ${!isFormVisible ? 'active' : ''}`}
                    onClick={() => onChangeScreen(false)}
                >
                    <img src="/player/images/eye.svg" alt="" width="24px" height="24px" />
                    Второй экран
                </button>
            </FormGroup>

            <FormGroup style={{margin: '8px 0 60px'}}>
                <SettingTabWrapper
                    title="Общие настройки"
                    label="commonSettings"
                >
                    <CommonSettings
                        eventSettings={eventSettings}
                        onChange={handleUpdateModel}
                    />
                </SettingTabWrapper>
                <SettingTabWrapper
                    title="Последовательность полей"
                    label="fieldsSequence"
                    isFormVisible={true}
                    onChangeScreen={onChangeScreen}
                >
                    <FieldsSequence
                        widgetKey={widgetKey}
                        participationType={participationType}
                        registrationType={registrationType}
                        onUpdatePreview={onUpdatePreview}
                    />
                </SettingTabWrapper>
                <SettingTabWrapper
                    title="Стиль полей"
                    label="fieldsStyles"
                    isFormVisible={true}
                    onChangeScreen={onChangeScreen}
                >
                    <FieldsStyles
                        eventSettings={eventSettings}
                        onChange={handleUpdateModel}
                    />
                </SettingTabWrapper>
                <SettingTabWrapper
                    title="Текст"
                    label="textSettings"
                >
                    <TextSettings
                        eventSettings={eventSettings}
                        onChange={handleUpdateModel}
                    />
                </SettingTabWrapper>
                <SettingTabWrapper
                    title="Содержание экранов"
                    label="screensContent"
                >
                    <ScreensContent
                        eventSettings={eventSettings}
                        eventName={eventName}
                        accessPreModeration={accessPreModeration}
                        onChangeModel={handleUpdateModel}
                        onChangeScreen={onChangeScreen}
                    />
                </SettingTabWrapper>
                <SettingTabWrapper
                    title="Яндекс Метрика"
                    label="yandexMetrika"
                >
                    <YandexMetrika />
                </SettingTabWrapper>
            </FormGroup>
        </FormGroup>
    );
};

export default SettingsSidebar;
